"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _classnames = _interopRequireDefault(require("classnames"));
var _cloneDeep2 = _interopRequireDefault(require("lodash/cloneDeep"));
var _map2 = _interopRequireDefault(require("lodash/map"));
var _sortBy2 = _interopRequireDefault(require("lodash/sortBy"));
var _momentTimezone = _interopRequireDefault(require("moment-timezone"));
var _cccisdConfirm = _interopRequireDefault(require("cccisd-confirm"));
var _cccisdDatepicker = _interopRequireDefault(require("cccisd-datepicker"));
var _cccisdTooltip = _interopRequireDefault(require("cccisd-tooltip"));
var _cccisdDetectClickLocation = _interopRequireDefault(require("cccisd-detect-click-location"));
var _schedulerStyle = _interopRequireDefault(require("./schedulerStyle.css"));
var _arrowDown = _interopRequireDefault(require("cccisd-icons/arrow-down5"));
var _plus = _interopRequireDefault(require("cccisd-icons/plus2"));
var _bin = _interopRequireDefault(require("cccisd-icons/bin"));
var _undo = _interopRequireDefault(require("cccisd-icons/undo"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread(); }
function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _iterableToArray(iter) { if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter); }
function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) return _arrayLikeToArray(arr); }
function _regeneratorRuntime() { "use strict"; /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/facebook/regenerator/blob/main/LICENSE */ _regeneratorRuntime = function _regeneratorRuntime() { return exports; }; var exports = {}, Op = Object.prototype, hasOwn = Op.hasOwnProperty, defineProperty = Object.defineProperty || function (obj, key, desc) { obj[key] = desc.value; }, $Symbol = "function" == typeof Symbol ? Symbol : {}, iteratorSymbol = $Symbol.iterator || "@@iterator", asyncIteratorSymbol = $Symbol.asyncIterator || "@@asyncIterator", toStringTagSymbol = $Symbol.toStringTag || "@@toStringTag"; function define(obj, key, value) { return Object.defineProperty(obj, key, { value: value, enumerable: !0, configurable: !0, writable: !0 }), obj[key]; } try { define({}, ""); } catch (err) { define = function define(obj, key, value) { return obj[key] = value; }; } function wrap(innerFn, outerFn, self, tryLocsList) { var protoGenerator = outerFn && outerFn.prototype instanceof Generator ? outerFn : Generator, generator = Object.create(protoGenerator.prototype), context = new Context(tryLocsList || []); return defineProperty(generator, "_invoke", { value: makeInvokeMethod(innerFn, self, context) }), generator; } function tryCatch(fn, obj, arg) { try { return { type: "normal", arg: fn.call(obj, arg) }; } catch (err) { return { type: "throw", arg: err }; } } exports.wrap = wrap; var ContinueSentinel = {}; function Generator() {} function GeneratorFunction() {} function GeneratorFunctionPrototype() {} var IteratorPrototype = {}; define(IteratorPrototype, iteratorSymbol, function () { return this; }); var getProto = Object.getPrototypeOf, NativeIteratorPrototype = getProto && getProto(getProto(values([]))); NativeIteratorPrototype && NativeIteratorPrototype !== Op && hasOwn.call(NativeIteratorPrototype, iteratorSymbol) && (IteratorPrototype = NativeIteratorPrototype); var Gp = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(IteratorPrototype); function defineIteratorMethods(prototype) { ["next", "throw", "return"].forEach(function (method) { define(prototype, method, function (arg) { return this._invoke(method, arg); }); }); } function AsyncIterator(generator, PromiseImpl) { function invoke(method, arg, resolve, reject) { var record = tryCatch(generator[method], generator, arg); if ("throw" !== record.type) { var result = record.arg, value = result.value; return value && "object" == _typeof(value) && hasOwn.call(value, "__await") ? PromiseImpl.resolve(value.__await).then(function (value) { invoke("next", value, resolve, reject); }, function (err) { invoke("throw", err, resolve, reject); }) : PromiseImpl.resolve(value).then(function (unwrapped) { result.value = unwrapped, resolve(result); }, function (error) { return invoke("throw", error, resolve, reject); }); } reject(record.arg); } var previousPromise; defineProperty(this, "_invoke", { value: function value(method, arg) { function callInvokeWithMethodAndArg() { return new PromiseImpl(function (resolve, reject) { invoke(method, arg, resolve, reject); }); } return previousPromise = previousPromise ? previousPromise.then(callInvokeWithMethodAndArg, callInvokeWithMethodAndArg) : callInvokeWithMethodAndArg(); } }); } function makeInvokeMethod(innerFn, self, context) { var state = "suspendedStart"; return function (method, arg) { if ("executing" === state) throw new Error("Generator is already running"); if ("completed" === state) { if ("throw" === method) throw arg; return doneResult(); } for (context.method = method, context.arg = arg;;) { var delegate = context.delegate; if (delegate) { var delegateResult = maybeInvokeDelegate(delegate, context); if (delegateResult) { if (delegateResult === ContinueSentinel) continue; return delegateResult; } } if ("next" === context.method) context.sent = context._sent = context.arg;else if ("throw" === context.method) { if ("suspendedStart" === state) throw state = "completed", context.arg; context.dispatchException(context.arg); } else "return" === context.method && context.abrupt("return", context.arg); state = "executing"; var record = tryCatch(innerFn, self, context); if ("normal" === record.type) { if (state = context.done ? "completed" : "suspendedYield", record.arg === ContinueSentinel) continue; return { value: record.arg, done: context.done }; } "throw" === record.type && (state = "completed", context.method = "throw", context.arg = record.arg); } }; } function maybeInvokeDelegate(delegate, context) { var method = delegate.iterator[context.method]; if (undefined === method) { if (context.delegate = null, "throw" === context.method) { if (delegate.iterator["return"] && (context.method = "return", context.arg = undefined, maybeInvokeDelegate(delegate, context), "throw" === context.method)) return ContinueSentinel; context.method = "throw", context.arg = new TypeError("The iterator does not provide a 'throw' method"); } return ContinueSentinel; } var record = tryCatch(method, delegate.iterator, context.arg); if ("throw" === record.type) return context.method = "throw", context.arg = record.arg, context.delegate = null, ContinueSentinel; var info = record.arg; return info ? info.done ? (context[delegate.resultName] = info.value, context.next = delegate.nextLoc, "return" !== context.method && (context.method = "next", context.arg = undefined), context.delegate = null, ContinueSentinel) : info : (context.method = "throw", context.arg = new TypeError("iterator result is not an object"), context.delegate = null, ContinueSentinel); } function pushTryEntry(locs) { var entry = { tryLoc: locs[0] }; 1 in locs && (entry.catchLoc = locs[1]), 2 in locs && (entry.finallyLoc = locs[2], entry.afterLoc = locs[3]), this.tryEntries.push(entry); } function resetTryEntry(entry) { var record = entry.completion || {}; record.type = "normal", delete record.arg, entry.completion = record; } function Context(tryLocsList) { this.tryEntries = [{ tryLoc: "root" }], tryLocsList.forEach(pushTryEntry, this), this.reset(!0); } function values(iterable) { if (iterable) { var iteratorMethod = iterable[iteratorSymbol]; if (iteratorMethod) return iteratorMethod.call(iterable); if ("function" == typeof iterable.next) return iterable; if (!isNaN(iterable.length)) { var i = -1, next = function next() { for (; ++i < iterable.length;) { if (hasOwn.call(iterable, i)) return next.value = iterable[i], next.done = !1, next; } return next.value = undefined, next.done = !0, next; }; return next.next = next; } } return { next: doneResult }; } function doneResult() { return { value: undefined, done: !0 }; } return GeneratorFunction.prototype = GeneratorFunctionPrototype, defineProperty(Gp, "constructor", { value: GeneratorFunctionPrototype, configurable: !0 }), defineProperty(GeneratorFunctionPrototype, "constructor", { value: GeneratorFunction, configurable: !0 }), GeneratorFunction.displayName = define(GeneratorFunctionPrototype, toStringTagSymbol, "GeneratorFunction"), exports.isGeneratorFunction = function (genFun) { var ctor = "function" == typeof genFun && genFun.constructor; return !!ctor && (ctor === GeneratorFunction || "GeneratorFunction" === (ctor.displayName || ctor.name)); }, exports.mark = function (genFun) { return Object.setPrototypeOf ? Object.setPrototypeOf(genFun, GeneratorFunctionPrototype) : (genFun.__proto__ = GeneratorFunctionPrototype, define(genFun, toStringTagSymbol, "GeneratorFunction")), genFun.prototype = Object.create(Gp), genFun; }, exports.awrap = function (arg) { return { __await: arg }; }, defineIteratorMethods(AsyncIterator.prototype), define(AsyncIterator.prototype, asyncIteratorSymbol, function () { return this; }), exports.AsyncIterator = AsyncIterator, exports.async = function (innerFn, outerFn, self, tryLocsList, PromiseImpl) { void 0 === PromiseImpl && (PromiseImpl = Promise); var iter = new AsyncIterator(wrap(innerFn, outerFn, self, tryLocsList), PromiseImpl); return exports.isGeneratorFunction(outerFn) ? iter : iter.next().then(function (result) { return result.done ? result.value : iter.next(); }); }, defineIteratorMethods(Gp), define(Gp, toStringTagSymbol, "Generator"), define(Gp, iteratorSymbol, function () { return this; }), define(Gp, "toString", function () { return "[object Generator]"; }), exports.keys = function (val) { var object = Object(val), keys = []; for (var key in object) { keys.push(key); } return keys.reverse(), function next() { for (; keys.length;) { var key = keys.pop(); if (key in object) return next.value = key, next.done = !1, next; } return next.done = !0, next; }; }, exports.values = values, Context.prototype = { constructor: Context, reset: function reset(skipTempReset) { if (this.prev = 0, this.next = 0, this.sent = this._sent = undefined, this.done = !1, this.delegate = null, this.method = "next", this.arg = undefined, this.tryEntries.forEach(resetTryEntry), !skipTempReset) for (var name in this) { "t" === name.charAt(0) && hasOwn.call(this, name) && !isNaN(+name.slice(1)) && (this[name] = undefined); } }, stop: function stop() { this.done = !0; var rootRecord = this.tryEntries[0].completion; if ("throw" === rootRecord.type) throw rootRecord.arg; return this.rval; }, dispatchException: function dispatchException(exception) { if (this.done) throw exception; var context = this; function handle(loc, caught) { return record.type = "throw", record.arg = exception, context.next = loc, caught && (context.method = "next", context.arg = undefined), !!caught; } for (var i = this.tryEntries.length - 1; i >= 0; --i) { var entry = this.tryEntries[i], record = entry.completion; if ("root" === entry.tryLoc) return handle("end"); if (entry.tryLoc <= this.prev) { var hasCatch = hasOwn.call(entry, "catchLoc"), hasFinally = hasOwn.call(entry, "finallyLoc"); if (hasCatch && hasFinally) { if (this.prev < entry.catchLoc) return handle(entry.catchLoc, !0); if (this.prev < entry.finallyLoc) return handle(entry.finallyLoc); } else if (hasCatch) { if (this.prev < entry.catchLoc) return handle(entry.catchLoc, !0); } else { if (!hasFinally) throw new Error("try statement without catch or finally"); if (this.prev < entry.finallyLoc) return handle(entry.finallyLoc); } } } }, abrupt: function abrupt(type, arg) { for (var i = this.tryEntries.length - 1; i >= 0; --i) { var entry = this.tryEntries[i]; if (entry.tryLoc <= this.prev && hasOwn.call(entry, "finallyLoc") && this.prev < entry.finallyLoc) { var finallyEntry = entry; break; } } finallyEntry && ("break" === type || "continue" === type) && finallyEntry.tryLoc <= arg && arg <= finallyEntry.finallyLoc && (finallyEntry = null); var record = finallyEntry ? finallyEntry.completion : {}; return record.type = type, record.arg = arg, finallyEntry ? (this.method = "next", this.next = finallyEntry.finallyLoc, ContinueSentinel) : this.complete(record); }, complete: function complete(record, afterLoc) { if ("throw" === record.type) throw record.arg; return "break" === record.type || "continue" === record.type ? this.next = record.arg : "return" === record.type ? (this.rval = this.arg = record.arg, this.method = "return", this.next = "end") : "normal" === record.type && afterLoc && (this.next = afterLoc), ContinueSentinel; }, finish: function finish(finallyLoc) { for (var i = this.tryEntries.length - 1; i >= 0; --i) { var entry = this.tryEntries[i]; if (entry.finallyLoc === finallyLoc) return this.complete(entry.completion, entry.afterLoc), resetTryEntry(entry), ContinueSentinel; } }, "catch": function _catch(tryLoc) { for (var i = this.tryEntries.length - 1; i >= 0; --i) { var entry = this.tryEntries[i]; if (entry.tryLoc === tryLoc) { var record = entry.completion; if ("throw" === record.type) { var thrown = record.arg; resetTryEntry(entry); } return thrown; } } throw new Error("illegal catch attempt"); }, delegateYield: function delegateYield(iterable, resultName, nextLoc) { return this.delegate = { iterator: values(iterable), resultName: resultName, nextLoc: nextLoc }, "next" === this.method && (this.arg = undefined), ContinueSentinel; } }, exports; }
function _createForOfIteratorHelper(o, allowArrayLike) { var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"]; if (!it) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e) { throw _e; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = it.call(o); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e2) { didErr = true; err = _e2; }, f: function f() { try { if (!normalCompletion && it["return"] != null) it["return"](); } finally { if (didErr) throw err; } } }; }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }
function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { Promise.resolve(value).then(_next, _throw); } }
function _asyncToGenerator(fn) { return function () { var self = this, args = arguments; return new Promise(function (resolve, reject) { var gen = fn.apply(self, args); function _next(value) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value); } function _throw(err) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err); } _next(undefined); }); }; }
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }
function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }
function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); Object.defineProperty(subClass, "prototype", { writable: false }); if (superClass) _setPrototypeOf(subClass, superClass); }
function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }
function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }
function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } else if (call !== void 0) { throw new TypeError("Derived constructors may only return object or undefined"); } return _assertThisInitialized(self); }
function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }
function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }
function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }
function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
var DATE_FORMAT_DATEPICKER = 'd MMM yyyy, h:mm a';
var DATE_FORMAT_MOMENT = 'D MMM YYYY, h:mm A';
var Scheduler = /*#__PURE__*/function (_React$Component) {
  _inherits(Scheduler, _React$Component);
  var _super = _createSuper(Scheduler);
  function Scheduler() {
    var _this;
    _classCallCheck(this, Scheduler);
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this = _super.call.apply(_super, [this].concat(args));
    _defineProperty(_assertThisInitialized(_this), "state", {
      isAddingSchedule: false,
      isListCollapsed: true,
      isSentCollapsed: true,
      completedScheduledMessageList: [],
      currentScheduledMessageList: [],
      tzAbbrev: _momentTimezone["default"].tz(_momentTimezone["default"].tz.guess()).format('z'),
      newDatetime: null,
      newInPast: false,
      newMessageKey: 1,
      editDatetime: null,
      editInPast: '',
      editMessageId: null
    });
    _defineProperty(_assertThisInitialized(_this), "sortScheduledMessageLists", /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee() {
      var templateMessageObject, children, completedScheduledMessageList, currentScheduledMessageList, _iterator, _step, child, clonedChild;
      return _regeneratorRuntime().wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              templateMessageObject = _this.props.templateMessageObject;
              children = templateMessageObject ? templateMessageObject.children : [];
              if (!(!children || !children.length)) {
                _context.next = 4;
                break;
              }
              return _context.abrupt("return");
            case 4:
              completedScheduledMessageList = [];
              currentScheduledMessageList = [];
              _iterator = _createForOfIteratorHelper(children);
              try {
                for (_iterator.s(); !(_step = _iterator.n()).done;) {
                  child = _step.value;
                  clonedChild = (0, _cloneDeep2["default"])(child);
                  if (clonedChild.completedAt) {
                    completedScheduledMessageList.push(clonedChild);
                  } else {
                    currentScheduledMessageList.push(clonedChild);
                  }
                }
              } catch (err) {
                _iterator.e(err);
              } finally {
                _iterator.f();
              }
              _context.next = 10;
              return _this.setState({
                completedScheduledMessageList: (0, _sortBy2["default"])(completedScheduledMessageList, 'scheduleTime'),
                currentScheduledMessageList: (0, _sortBy2["default"])(currentScheduledMessageList, 'scheduleTime')
              });
            case 10:
            case "end":
              return _context.stop();
          }
        }
      }, _callee);
    })));
    _defineProperty(_assertThisInitialized(_this), "toggleCollapse", function () {
      _this.setState(function (prevState) {
        return {
          isListCollapsed: !prevState.isListCollapsed,
          isAddingSchedule: prevState.isListCollapsed
        };
      });
    });
    _defineProperty(_assertThisInitialized(_this), "toggleSent", function () {
      _this.setState(function (prevState) {
        return {
          isSentCollapsed: !prevState.isSentCollapsed
        };
      });
    });
    _defineProperty(_assertThisInitialized(_this), "onSelect", function (value) {
      _this.setState({
        newDatetime: value
      });
    });
    _defineProperty(_assertThisInitialized(_this), "onSelectEdit", function (value) {
      _this.setState({
        editDatetime: value
      });
    });
    _defineProperty(_assertThisInitialized(_this), "addSchedule", /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee2() {
      var newScheduleItem;
      return _regeneratorRuntime().wrap(function _callee2$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              if (_this.state.newDatetime) {
                _context2.next = 2;
                break;
              }
              return _context2.abrupt("return");
            case 2:
              if (!(new Date().getTime() > _this.state.newDatetime.getTime())) {
                _context2.next = 7;
                break;
              }
              _context2.next = 5;
              return _this.setState({
                newInPast: true
              });
            case 5:
              _this.props.onScheduleError();
              return _context2.abrupt("return");
            case 7:
              newScheduleItem = {
                messageId: "new".concat(_this.state.newMessageKey),
                scheduleTime: (0, _momentTimezone["default"])(_this.state.newDatetime).utc().format(),
                isNew: true
              };
              _context2.next = 10;
              return _this.setState(function (prevState) {
                return {
                  currentScheduledMessageList: [].concat(_toConsumableArray(prevState.currentScheduledMessageList), [newScheduleItem]),
                  newMessageKey: prevState.newMessageKey + 1,
                  newInPast: false
                };
              });
            case 10:
              _this.props.onScheduleChange(_this.state.currentScheduledMessageList);
              _this.clearNewItem();
            case 12:
            case "end":
              return _context2.stop();
          }
        }
      }, _callee2);
    })));
    _defineProperty(_assertThisInitialized(_this), "additionalOutsideTest", function (e) {
      // if you click in the calendar, don't close the picker yet
      var node = e.target;
      var isClickedCalendar = false;
      while (node) {
        if (node.id === 'cccisd-datepicker') {
          isClickedCalendar = true;
          break;
        }
        node = node.parentNode;
      }
      return !isClickedCalendar;
    });
    _defineProperty(_assertThisInitialized(_this), "clearNewItem", /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee3() {
      return _regeneratorRuntime().wrap(function _callee3$(_context3) {
        while (1) {
          switch (_context3.prev = _context3.next) {
            case 0:
              _context3.next = 2;
              return _this.setState({
                isAddingSchedule: false,
                newInPast: false,
                newDatetime: null
              });
            case 2:
              if (!_this.state.editInPast) {
                _this.props.onScheduleErrorResolved();
              }
            case 3:
            case "end":
              return _context3.stop();
          }
        }
      }, _callee3);
    })));
    _defineProperty(_assertThisInitialized(_this), "editSchedule", /*#__PURE__*/function () {
      var _ref4 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee4(message) {
        var scheduleTime;
        return _regeneratorRuntime().wrap(function _callee4$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {
              case 0:
                scheduleTime = _typeof(message.scheduleTime) === 'object' ? message.scheduleTime : (0, _momentTimezone["default"])(_momentTimezone["default"].utc(message.scheduleTime).format()).toDate();
                if (!message.originalScheduleTime) {
                  message.originalScheduleTime = message.scheduleTime;
                }
                delete message.toDelete;
                _context4.next = 5;
                return _this.setState({
                  editDatetime: scheduleTime,
                  editInPast: '',
                  editMessageId: message.messageId
                });
              case 5:
                if (_this.state.newInPast) {
                  _context4.next = 8;
                  break;
                }
                _context4.next = 8;
                return _this.props.onScheduleErrorResolved();
              case 8:
              case "end":
                return _context4.stop();
            }
          }
        }, _callee4);
      }));
      return function (_x) {
        return _ref4.apply(this, arguments);
      };
    }());
    _defineProperty(_assertThisInitialized(_this), "completeEdit", /*#__PURE__*/function () {
      var _ref5 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee5(message) {
        return _regeneratorRuntime().wrap(function _callee5$(_context5) {
          while (1) {
            switch (_context5.prev = _context5.next) {
              case 0:
                if (!(new Date().getTime() > _this.state.editDatetime.getTime())) {
                  _context5.next = 5;
                  break;
                }
                _context5.next = 3;
                return _this.setState({
                  editInPast: message.messageId
                });
              case 3:
                _this.props.onScheduleError();
                return _context5.abrupt("return");
              case 5:
                message.scheduleTime = (0, _momentTimezone["default"])(_this.state.editDatetime).utc().format();
                _context5.next = 8;
                return _this.props.onScheduleChange(_this.state.currentScheduledMessageList);
              case 8:
                _context5.next = 10;
                return _this.setState({
                  editDatetime: null,
                  editInPast: '',
                  editMessageId: null
                });
              case 10:
                if (_this.state.newInPast) {
                  _context5.next = 13;
                  break;
                }
                _context5.next = 13;
                return _this.props.onScheduleErrorResolved();
              case 13:
              case "end":
                return _context5.stop();
            }
          }
        }, _callee5);
      }));
      return function (_x2) {
        return _ref5.apply(this, arguments);
      };
    }());
    _defineProperty(_assertThisInitialized(_this), "revertEditedToOriginal", /*#__PURE__*/function () {
      var _ref6 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee6(message) {
        return _regeneratorRuntime().wrap(function _callee6$(_context6) {
          while (1) {
            switch (_context6.prev = _context6.next) {
              case 0:
                message.scheduleTime = message.originalScheduleTime;
                _context6.next = 3;
                return _this.setState({
                  editDatetime: null,
                  editInPast: '',
                  editMessageId: null
                });
              case 3:
                if (_this.state.newInPast) {
                  _context6.next = 6;
                  break;
                }
                _context6.next = 6;
                return _this.props.onScheduleErrorResolved();
              case 6:
              case "end":
                return _context6.stop();
            }
          }
        }, _callee6);
      }));
      return function (_x3) {
        return _ref6.apply(this, arguments);
      };
    }());
    _defineProperty(_assertThisInitialized(_this), "removeSchedule", /*#__PURE__*/function () {
      var _ref7 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee7(message) {
        var newList, newPartialState, foundMessage, _iterator2, _step2, item;
        return _regeneratorRuntime().wrap(function _callee7$(_context7) {
          while (1) {
            switch (_context7.prev = _context7.next) {
              case 0:
                newList = [];
                newPartialState = {};
                foundMessage = false;
                _iterator2 = _createForOfIteratorHelper(_this.state.currentScheduledMessageList);
                _context7.prev = 4;
                _iterator2.s();
              case 6:
                if ((_step2 = _iterator2.n()).done) {
                  _context7.next = 19;
                  break;
                }
                item = _step2.value;
                if (!(item.messageId === message.messageId)) {
                  _context7.next = 16;
                  break;
                }
                foundMessage = true;
                if (message.messageId === _this.state.editInPast) {
                  newPartialState.editInPast = '';
                }
                if (message.isNew) {
                  _context7.next = 15;
                  break;
                }
                item.toDelete = true;
                _context7.next = 16;
                break;
              case 15:
                return _context7.abrupt("continue", 17);
              case 16:
                newList.push(item);
              case 17:
                _context7.next = 6;
                break;
              case 19:
                _context7.next = 24;
                break;
              case 21:
                _context7.prev = 21;
                _context7.t0 = _context7["catch"](4);
                _iterator2.e(_context7.t0);
              case 24:
                _context7.prev = 24;
                _iterator2.f();
                return _context7.finish(24);
              case 27:
                if (!foundMessage) {
                  newPartialState.newInPast = false;
                }
                newPartialState.currentScheduledMessageList = newList;
                _context7.next = 31;
                return _this.setState(_objectSpread({}, newPartialState));
              case 31:
                _context7.next = 33;
                return _this.props.onScheduleChange(newList);
              case 33:
                if (!(!_this.state.newInPast && !_this.state.editInPast)) {
                  _context7.next = 36;
                  break;
                }
                _context7.next = 36;
                return _this.props.onScheduleErrorResolved();
              case 36:
              case "end":
                return _context7.stop();
            }
          }
        }, _callee7, null, [[4, 21, 24, 27]]);
      }));
      return function (_x4) {
        return _ref7.apply(this, arguments);
      };
    }());
    _defineProperty(_assertThisInitialized(_this), "restoreSchedule", function (messageId) {
      var newList = [];
      var _iterator3 = _createForOfIteratorHelper(_this.state.currentScheduledMessageList),
        _step3;
      try {
        for (_iterator3.s(); !(_step3 = _iterator3.n()).done;) {
          var item = _step3.value;
          if (item.messageId === messageId) {
            delete item.toDelete;
          }
          newList.push(item);
        }
      } catch (err) {
        _iterator3.e(err);
      } finally {
        _iterator3.f();
      }
      _this.setState({
        currentScheduledMessageList: newList
      });
      _this.props.onScheduleChange(newList);
    });
    _defineProperty(_assertThisInitialized(_this), "_renderScheduleList", function () {
      var _this$state = _this.state,
        currentScheduledMessageList = _this$state.currentScheduledMessageList,
        isAddingSchedule = _this$state.isAddingSchedule,
        editInPast = _this$state.editInPast,
        newDatetime = _this$state.newDatetime,
        newInPast = _this$state.newInPast,
        tzAbbrev = _this$state.tzAbbrev;
      var allList = _toConsumableArray(currentScheduledMessageList);
      return /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, /*#__PURE__*/_react["default"].createElement("ul", {
        className: _schedulerStyle["default"].Panel_listArea
      }, allList.length > 0 && /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, (0, _map2["default"])(allList, function (message) {
        return /*#__PURE__*/_react["default"].createElement("li", {
          key: message.messageId,
          className: (0, _classnames["default"])(message.toDelete ? _schedulerStyle["default"].toDelete : '', _schedulerStyle["default"].Panel_listItem)
        }, _this._renderScheduledCell(message));
      })), isAddingSchedule && /*#__PURE__*/_react["default"].createElement("li", {
        className: (0, _classnames["default"])('form-group', _schedulerStyle["default"].Panel_listItem)
      }, /*#__PURE__*/_react["default"].createElement("span", {
        className: _schedulerStyle["default"].Panel_listItem___column1
      }, /*#__PURE__*/_react["default"].createElement(_cccisdTooltip["default"], {
        title: "Delete"
      }, /*#__PURE__*/_react["default"].createElement("a", {
        className: (0, _classnames["default"])('btn btn-danger', _schedulerStyle["default"].forceTextWhite, _schedulerStyle["default"].Panel_listItem___column1),
        onClick: function onClick() {
          _this.clearNewItem();
        }
      }, /*#__PURE__*/_react["default"].createElement(_bin["default"], null)))), /*#__PURE__*/_react["default"].createElement("div", {
        className: _schedulerStyle["default"].Panel_listItem___column2
      }, /*#__PURE__*/_react["default"].createElement(_cccisdDetectClickLocation["default"], {
        additionalOutsideTest: _this.additionalOutsideTest,
        className: (0, _classnames["default"])(_schedulerStyle["default"].datePicker, newInPast ? _schedulerStyle["default"].datePicker___Error : null),
        clickedOutside: function clickedOutside() {
          _this.addSchedule();
        }
      }, /*#__PURE__*/_react["default"].createElement(_cccisdDatepicker["default"], {
        selected: newDatetime !== null ? newDatetime : null,
        onChange: _this.onSelect,
        dateFormat: DATE_FORMAT_DATEPICKER,
        placeholderText: "Enter date and time",
        showTimeSelect: true
      }), /*#__PURE__*/_react["default"].createElement("span", {
        className: "input-group-addon"
      }, tzAbbrev)))), /*#__PURE__*/_react["default"].createElement("li", {
        className: (0, _classnames["default"])('form-group', _schedulerStyle["default"].Panel_listItem)
      }, /*#__PURE__*/_react["default"].createElement("a", {
        className: (0, _classnames["default"])('btn btn-primary', _schedulerStyle["default"].forceTextWhite, _schedulerStyle["default"].fullWidth),
        onClick: function onClick() {
          if (!_this.state.isAddingSchedule) {
            _this.setState({
              isAddingSchedule: true
            });
          }
        }
      }, /*#__PURE__*/_react["default"].createElement(_plus["default"], null), "\xA0\xA0Add Schedule"))), newInPast || editInPast ? /*#__PURE__*/_react["default"].createElement("div", {
        className: (0, _classnames["default"])('alert alert-danger text-danger', _schedulerStyle["default"].Panel_error)
      }, "Scheduled dates must be in the future") : null);
    });
    _defineProperty(_assertThisInitialized(_this), "_renderSentList", function () {
      var allList = _toConsumableArray(_this.state.completedScheduledMessageList);
      return /*#__PURE__*/_react["default"].createElement("ul", {
        className: _schedulerStyle["default"].Panel_listArea
      }, allList.length > 0 && /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, (0, _map2["default"])(allList, function (message) {
        return /*#__PURE__*/_react["default"].createElement("li", {
          key: message.messageId,
          className: _schedulerStyle["default"].Panel_listItem
        }, _this._renderSentCell(message.completedAt));
      })));
    });
    _defineProperty(_assertThisInitialized(_this), "_renderScheduledCell", function (message) {
      var _this$state2 = _this.state,
        editDatetime = _this$state2.editDatetime,
        editInPast = _this$state2.editInPast,
        editMessageId = _this$state2.editMessageId,
        tzAbbrev = _this$state2.tzAbbrev;
      var messageId = message.messageId,
        scheduleTime = message.scheduleTime,
        isNew = message.isNew,
        toDelete = message.toDelete;
      var isExisting = !isNew;
      if (message.messageId === editMessageId) {
        return /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, /*#__PURE__*/_react["default"].createElement("div", {
          className: _schedulerStyle["default"].Panel_listItem___column1
        }, /*#__PURE__*/_react["default"].createElement(_cccisdTooltip["default"], {
          title: "Cancel Edit Schedule"
        }, /*#__PURE__*/_react["default"].createElement("a", {
          className: (0, _classnames["default"])('btn btn-default', _schedulerStyle["default"].forceTextGray),
          onClick: function onClick() {
            _this.revertEditedToOriginal(message);
          }
        }, /*#__PURE__*/_react["default"].createElement(_undo["default"], null)))), /*#__PURE__*/_react["default"].createElement("div", {
          className: _schedulerStyle["default"].Panel_listItem___column2
        }, /*#__PURE__*/_react["default"].createElement(_cccisdDetectClickLocation["default"], {
          additionalOutsideTest: _this.additionalOutsideTest,
          className: (0, _classnames["default"])(_schedulerStyle["default"].datePicker, editInPast ? _schedulerStyle["default"].datePicker___Error : null),
          clickedOutside: function clickedOutside() {
            _this.completeEdit(message);
          }
        }, /*#__PURE__*/_react["default"].createElement(_cccisdDatepicker["default"], {
          selected: editDatetime,
          onChange: _this.onSelectEdit,
          dateFormat: DATE_FORMAT_DATEPICKER,
          placeholderText: "Enter date and time",
          showTimeSelect: true
        }), /*#__PURE__*/_react["default"].createElement("span", {
          className: "input-group-addon"
        }, tzAbbrev))));
      }
      return /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, toDelete ? /*#__PURE__*/_react["default"].createElement(_cccisdTooltip["default"], {
        title: "Undo Delete",
        className: _schedulerStyle["default"].Panel_listItem___column1
      }, /*#__PURE__*/_react["default"].createElement("a", {
        className: (0, _classnames["default"])('btn btn-primary', _schedulerStyle["default"].forceTextWhite),
        onClick: function onClick() {
          _this.restoreSchedule(messageId);
        }
      }, /*#__PURE__*/_react["default"].createElement(_undo["default"], null))) : /*#__PURE__*/_react["default"].createElement(_cccisdTooltip["default"], {
        title: "Delete",
        type: "error",
        className: _schedulerStyle["default"].Panel_listItem___column1
      }, /*#__PURE__*/_react["default"].createElement("a", {
        className: (0, _classnames["default"])('btn btn-danger', _schedulerStyle["default"].forceTextWhite),
        onClick: function onClick() {
          if (isExisting) {
            (0, _cccisdConfirm["default"])({
              message: 'Mark deleted',
              description: 'Mark scheduled message for deletion? Deletion will be performed when form is submitted.',
              confirmLabel: 'Yes',
              abortLabel: 'Cancel'
            }).then(function () {
              _this.removeSchedule(message);
            });
          } else {
            _this.removeSchedule(message);
          }
        }
      }, /*#__PURE__*/_react["default"].createElement(_bin["default"], null))), /*#__PURE__*/_react["default"].createElement("div", {
        className: _schedulerStyle["default"].Panel_listItem___column2
      }, /*#__PURE__*/_react["default"].createElement("a", {
        className: (0, _classnames["default"])(_schedulerStyle["default"].textColor, _schedulerStyle["default"].noUnderline),
        onClick: function onClick() {
          _this.editSchedule(message);
        }
      }, (0, _momentTimezone["default"])(_momentTimezone["default"].utc(scheduleTime).format()).format(DATE_FORMAT_MOMENT), " (", tzAbbrev, ")")));
    });
    _defineProperty(_assertThisInitialized(_this), "_renderSentCell", function (datetime) {
      return /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, /*#__PURE__*/_react["default"].createElement("div", {
        className: _schedulerStyle["default"].Panel_listItem___column1
      }), /*#__PURE__*/_react["default"].createElement("span", {
        className: (0, _classnames["default"])(_schedulerStyle["default"].textColor, _schedulerStyle["default"].Panel_listItem___column2)
      }, (0, _momentTimezone["default"])(_momentTimezone["default"].utc(datetime).format()).format(DATE_FORMAT_MOMENT), " (", _this.state.tzAbbrev, ")"));
    });
    return _this;
  }
  _createClass(Scheduler, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      this.sortScheduledMessageLists();
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      var _iterator4 = _createForOfIteratorHelper(this.state.currentScheduledMessageList),
        _step4;
      try {
        for (_iterator4.s(); !(_step4 = _iterator4.n()).done;) {
          var child = _step4.value;
          if (child.toDelete) {
            delete child.toDelete;
          }
        }
      } catch (err) {
        _iterator4.e(err);
      } finally {
        _iterator4.f();
      }
    }
  }, {
    key: "render",
    value: function render() {
      var sentStyle = this.state.isSentCollapsed ? _schedulerStyle["default"].Panel_collapseArrow___collapsed : _schedulerStyle["default"].Panel_collapseArrow___expanded;
      var collapseStyle = this.state.isListCollapsed ? _schedulerStyle["default"].Panel_collapseArrow___collapsed : _schedulerStyle["default"].Panel_collapseArrow___expanded;
      var sentNum = this.state.completedScheduledMessageList.length;
      var scheduledNum = this.state.currentScheduledMessageList.filter(function (item) {
        return !item.toDelete;
      }).length;
      return /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, !sentNum ? null : /*#__PURE__*/_react["default"].createElement("div", {
        className: (0, _classnames["default"])('panel panel-primary', _schedulerStyle["default"].Panel, _schedulerStyle["default"].Panel___sent)
      }, /*#__PURE__*/_react["default"].createElement("div", {
        className: (0, _classnames["default"])('panel-heading', _schedulerStyle["default"].Panel_header, _schedulerStyle["default"].Panel_header___gray)
      }, /*#__PURE__*/_react["default"].createElement("div", {
        className: _schedulerStyle["default"].Panel_collapseArrow,
        onClick: this.toggleSent.bind(null)
      }, /*#__PURE__*/_react["default"].createElement("div", {
        className: sentStyle
      }, /*#__PURE__*/_react["default"].createElement(_arrowDown["default"], null))), /*#__PURE__*/_react["default"].createElement("h3", {
        onClick: this.toggleSent.bind(null),
        className: (0, _classnames["default"])('panel-title', _schedulerStyle["default"].Panel_headerText)
      }, "Sent List ", "(".concat(sentNum, ")"))), !this.state.isSentCollapsed && this._renderSentList()), /*#__PURE__*/_react["default"].createElement("div", {
        className: (0, _classnames["default"])('panel panel-primary', _schedulerStyle["default"].Panel)
      }, /*#__PURE__*/_react["default"].createElement("div", {
        className: (0, _classnames["default"])('panel-heading', _schedulerStyle["default"].Panel_header)
      }, /*#__PURE__*/_react["default"].createElement("div", {
        className: _schedulerStyle["default"].Panel_collapseArrow,
        onClick: this.toggleCollapse.bind(null)
      }, /*#__PURE__*/_react["default"].createElement("div", {
        className: collapseStyle
      }, /*#__PURE__*/_react["default"].createElement(_arrowDown["default"], null))), /*#__PURE__*/_react["default"].createElement("h3", {
        onClick: this.toggleCollapse.bind(null),
        className: (0, _classnames["default"])('panel-title', _schedulerStyle["default"].Panel_headerText)
      }, "Scheduling List ", "(".concat(scheduledNum, ")"))), !this.state.isListCollapsed && this._renderScheduleList()));
    }
  }]);
  return Scheduler;
}(_react["default"].Component);
exports["default"] = Scheduler;
_defineProperty(Scheduler, "propTypes", {
  deploymentId: _propTypes["default"].number.isRequired,
  templateMessageObject: _propTypes["default"].object,
  onScheduleChange: _propTypes["default"].func,
  onScheduleError: _propTypes["default"].func,
  onScheduleErrorResolved: _propTypes["default"].func
});
_defineProperty(Scheduler, "defaultProps", {
  templateMessageObject: null,
  onScheduleChange: function onScheduleChange() {}
});